module.exports = __webpack_public_path__ + "img/thirdly.fecc5e2b.png";